var storage = {
    getStorage(key) {
        return localStorage.getItem(key)
    }
}
export default storage